"use client"

import { useLocale } from "@/i18n/provider"
import { TemporaryErrorScreen } from "@/components/system-status/temporary-error-screen"

// The error detail is never shown: it may contain internal URLs or payloads.
export default function Error({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const { locale } = useLocale()
  return <TemporaryErrorScreen locale={locale} reset={reset} />
}
